import React, { Fragment } from 'react';
import { Gauge, Heart, Layers, Users, Settings, Coins, RefreshCw, ExternalLink, Star, ArrowUpRight, Brain, DollarSign, BarChart, MousePointerClick, RotateCcw } from 'lucide-react';
interface SidebarProps {
  activeSection: string;
  setActiveSection: (section: string) => void;
}
export const Sidebar: React.FC<SidebarProps> = ({
  activeSection,
  setActiveSection
}) => {
  const sections = [{
    id: 'segmentation-hub',
    name: 'Segmentation Hub',
    icon: <Users size={18} data-id="element-14568" />
  }, {
    id: 'engagement-rituals',
    name: 'Engagement Rituals',
    icon: <Heart size={18} data-id="element-14569" />
  }, {
    id: 'token-economy',
    name: 'Token Economy',
    icon: <Coins size={18} data-id="element-14570" />
  }, {
    id: 'upsell-layers',
    name: 'Upsell Layers',
    icon: <Layers size={18} data-id="element-14571" />
  }, {
    id: 're-engagement',
    name: 'Re-Engagement Tools',
    icon: <RefreshCw size={18} data-id="element-14572" />
  }, {
    id: 'fallback-monetization',
    name: 'Fallback Monetization',
    icon: <ExternalLink size={18} data-id="element-14573" />
  }, {
    id: 'offers',
    name: 'Offers',
    icon: <DollarSign size={18} data-id="element-14574" />,
    subSections: [{
      id: 'offers-home',
      name: 'Overview',
      icon: <BarChart size={16} data-id="element-14575" />
    }, {
      id: 'backoffers',
      name: 'Backoffers',
      icon: <ExternalLink size={16} data-id="element-14576" />
    }, {
      id: 'second-click-offers',
      name: 'Second-Click',
      icon: <MousePointerClick size={16} data-id="element-14577" />
    }, {
      id: 'smartlinks',
      name: 'Smartlinks/Rotators',
      icon: <RotateCcw size={16} data-id="element-14578" />
    }]
  }, {
    id: 'angel-studio',
    name: 'Angel Studio',
    icon: <Star size={18} data-id="element-14579" />
  }, {
    id: 'cross-vertical',
    name: 'Cross Vertical',
    icon: <ArrowUpRight size={18} data-id="element-14580" />
  }, {
    id: 'owner-control',
    name: 'Owner Control Layer',
    icon: <Settings size={18} data-id="element-14581" />
  }];
  return <div className="w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 flex-shrink-0 overflow-y-auto" data-id="element-14582">
      <div className="p-6" data-id="element-14583">
        <div className="flex items-center" data-id="element-14584">
          <Brain size={24} className="text-purple-600 dark:text-purple-400" data-id="element-14585" />
          <h2 className="ml-3 text-xl font-bold text-gray-900 dark:text-white" data-id="element-14586">
            Monetization
          </h2>
        </div>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400" data-id="element-14587">
          Personalized Algorithmic & Segmentation Monetization Board
        </p>
      </div>
      <div className="px-3 py-2" data-id="element-14588">
        <div className="space-y-1" data-id="element-14589">
          {sections.map(section => <Fragment key={section.id} data-id="element-14590">
              <button onClick={() => setActiveSection(section.id)} className={`w-full flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${activeSection === section.id || section.subSections && section.subSections.some(sub => activeSection === sub.id) ? 'bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-400' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'}`} data-id="element-14591">
                <span className={`mr-3 ${activeSection === section.id || section.subSections && section.subSections.some(sub => activeSection === sub.id) ? 'text-purple-500 dark:text-purple-400' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-14592">
                  {section.icon}
                </span>
                {section.name}
              </button>
              {section.subSections && (activeSection === section.id || section.subSections.some(sub => activeSection === sub.id)) && <div className="ml-6 mt-1 space-y-1" data-id="element-14593">
                    {section.subSections.map(subSection => <button key={subSection.id} onClick={() => setActiveSection(subSection.id)} className={`w-full flex items-center px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${activeSection === subSection.id ? 'bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-400' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'}`} data-id="element-14594">
                        <span className={`mr-2 ${activeSection === subSection.id ? 'text-purple-500 dark:text-purple-400' : 'text-gray-500 dark:text-gray-400'}`} data-id="element-14595">
                          {subSection.icon}
                        </span>
                        {subSection.name}
                      </button>)}
                  </div>}
            </Fragment>)}
        </div>
      </div>
    </div>;
};